import * as React from 'react'

import classNames from 'classnames/bind'

import styles from './index.module.css'

interface Props {
  type: 'warning' | 'danger' | 'default' | 'rebranding'
}

const cx = classNames.bind(styles)

const TopBanner = (props: React.PropsWithChildren<Props>) => {
  return (
    <div className={cx('top-banner', props.type)}>
      <div className={cx('top-banner-body')}>{props.children}</div>
    </div>
  )
}

export default TopBanner
